import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { globalVar } from 'src/app/shared/global_variables';
import { environment } from 'src/environments/environment';
import { Tooltip } from './Tooltip';

export const TOOLTIP = '/tooltip';
export const SEARCH_TOOLTIPS = TOOLTIP + '/searchTooltips';

@Injectable({
    providedIn: 'root'
})
export class TooltipService {
    constructor(private httpClient: HttpClient) {}

    public searchTooltips(): Observable<Tooltip[]> {
        return this.httpClient.post<Tooltip[]>(environment.baseUrl + globalVar.requestPrefix + SEARCH_TOOLTIPS, null);
    }
}
